module.exports = __webpack_public_path__ + "img/img-spadegaming-fish-s.0176684b.png";